import { Injectable } from '@angular/core';
import { ConvertHelper } from '@barthauer/abc/core';
import { LoginInfo, UserPersonInfo, UserService } from '@barthauer/abc/core/authentication';
import { DataService as CoreDataService, Query, QueryColumn, QueryObjectsModel } from '@barthauer/abc/core/data';
import { firstValueFrom } from 'rxjs';

@Injectable()
export class DataService {
  private loginInfo: LoginInfo;
  private currentUserInfo: UserPersonInfo;

  constructor(private coreDataService: CoreDataService, private userService: UserService) {}
  private prepareQueryUserPersonInfo(): QueryObjectsModel {
    const queryColumns: Array<QueryColumn> = [
      this.coreDataService.createQueryColumn('Id', 'Id'),
      this.coreDataService.createQueryColumn('ref:Id', 'FullName'),
      this.coreDataService.createQueryColumn('LastName', 'LastName'),
      this.coreDataService.createQueryColumn('FirstName', 'FirstName'),
      this.coreDataService.createQueryColumn('ParentId', 'ParentId'),
      this.coreDataService.createQueryColumn('ref:ParentId', 'CompanyName'),
      this.coreDataService.createQueryColumn('EMail', 'EMail'),
      this.coreDataService.createQueryColumn('Salutation', 'Salutation'),
      this.coreDataService.createQueryColumn('Shorthand', 'Shorthand'),
      this.coreDataService.createQueryColumn('Department', 'Department'),
      this.coreDataService.createQueryColumn('Position', 'Position'),
      {
        Name: 'ImgPortrait',
        OPath: 'Documents[ParentId = ^.Id].Object',
        Format: 'Base64Image[400x400]',
      },
    ];

    const mainQuery: Query = new Query();
    mainQuery.ObjectType = 'Person';
    mainQuery.OPath = 'Id = $CurrentUserId';
    mainQuery.Columns = queryColumns;

    const queryDocument: QueryObjectsModel = new QueryObjectsModel();
    queryDocument.ObjectQueries = [mainQuery];

    return queryDocument;
  }

  private async getCurrentUserPersonInfo(): Promise<UserPersonInfo> {
    const user: UserPersonInfo = <UserPersonInfo>(
      ConvertHelper.arrayBufferToObject(
        await firstValueFrom(this.coreDataService.executeReadObjectsQuery(this.prepareQueryUserPersonInfo()))
      )
    );
    return user;
  }

  async getUserInformations(): Promise<{ person: UserPersonInfo; loginInfo: LoginInfo }> {
    this.loginInfo ??= await firstValueFrom(this.userService.getCurrentLoginInfo());
    this.currentUserInfo ??= await this.getCurrentUserPersonInfo();
    return { person: this.currentUserInfo, loginInfo: this.loginInfo };
  }
}

export enum ObjectKeys {
  PERSON = 'Person',
  DOCUMENT = 'Document',
  MAILADDRESS = 'MailAddress',
  PHONENUMBER = 'PhoneNumber',
}
